import { get, del } from '@nbx/frontend-helpers/fetch-api';
import { context } from '@nbx/frontend-helpers/auth';

let baseUrl = 'markets';

const NBXMarkets = {
  init: config => ({ baseUrl } = config),

  getMarketTicker: pair => get(`${baseUrl}/markets/${pair}/ticker`).then(r => r.ticker),

  cancelOrder: (marketId, orderId) =>
    context.account().then(account => del(`${baseUrl}/${marketId}/orders/${orderId}`, {}, account))
};

export default NBXMarkets;
